import React from 'react';

import PropertyGridComponent, { PropertyGridStringValue } from '../../../shared/components/property-grid/property-grid-component';
import { getDate, formatDate } from '../../../shared/helpers/date-helper';
import { convertUnixTimeStamp } from '../../helpers/date-helper';

const IDS = {
  WELL_NAME: 10,
};
Object.freeze(IDS);

const getSections = (govtDataWellJson, attributeAliases, attributeTypes) => {

  const newRows = [];

  let jsonData = JSON.parse(govtDataWellJson);

  Object.keys(attributeAliases).forEach(aliasKey => {
    Object.keys(jsonData).forEach(key => {
      if (key === aliasKey) {
        if (jsonData[key] !== null && jsonData[key] !== undefined && jsonData[key] !== '') {
          var jsonValue = jsonData[key];

          Object.keys(attributeTypes).forEach(type => {
            if (type === key && attributeTypes[type] === 3) {
              jsonValue = convertUnixTimeStamp(jsonValue);
              jsonValue = formatDate(jsonValue);
            }
            else if (type === key && attributeTypes[type] === 2) {
              jsonValue = getDate(jsonValue);
              jsonValue = formatDate(jsonValue);
            }
          });

          newRows.push({ label: attributeAliases[aliasKey], values: [new PropertyGridStringValue(IDS.WELL_NAME, jsonValue)] });
        }
        
      }

    });
  });

  const result = [
    {
      label: 'Govt Data Well Information',

      rows: newRows

    },

  ];

  return result;
};

const GovtDataWellComponent = (props) => {
  const { govtDataWellJson, attributeAliases, attributeTypes } = props;

  const sections = getSections(govtDataWellJson, attributeAliases, attributeTypes);

  return <PropertyGridComponent sections={sections} readOnly={true} />;
};

GovtDataWellComponent.propTypes = {
};

export default GovtDataWellComponent;
